module.exports = __webpack_public_path__ + "static/media/fleetvehiclesIcon.ee3bf6d9.svg";